import { CompanyEntity } from './company';

export enum UserRole {
  ADMIN = 'Administrador',
  COLLABORATOR = 'Colaborador',
}

export type UserEntity = {
  id: string;
  typeDescription: UserRole;
  name: string;
  email: string;
  company: CompanyEntity;
};
